<template>
    <div class="d-flex justify-content-end mb-1" v-if="mostraPager">
        <div class="pt-2">Elementi per pagina:&nbsp;</div>
        <div>
            <select class="form-control" v-model="elementiPagina" style="width:100px;" @change="$emit('CambiaElementi', elementiPagina)">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="500">500</option>
            </select>
        </div>

    </div>
    
  
  <table :class="'table ' + classiTable">
    <thead>
        <tr>
            <th v-for="c, ndx in colonneHeader" :key="ndx">
                {{ c }} &nbsp;
                <a @click="$emit('Ordina',ndx)" class="aOrdina" v-if="!colonneNoOrder.includes(colonne[ndx])">
                    <font-awesome-icon :icon="'fa-solid fa-arrow-down-short-wide'"></font-awesome-icon>
                </a>
            </th>
            <th></th>
        </tr>
    </thead>
    <tbody>
        <tr v-for="e, ndx in dati" :key="ndx" @dblclick="$emit('Seleziona', e)">
            <td v-for="v, ndxv in colonne" :key="ndxv">
                <template v-if="!IsBoolean(e, ndxv)"><span v-html="GetValue(e, ndxv)"></span></template>
                <template v-else>
                    <font-awesome-icon :icon="'fa-solid fa-check'" v-if="GetValue(e, ndxv) == true" class="text-success"></font-awesome-icon>
                    <font-awesome-icon :icon="'fa-solid fa-times'" v-else class="text-dark"></font-awesome-icon>
                </template>
            </td> 
            <td>
                <a v-for="cmd, ndc in comandi" :key="ndc" :title="cmd.titolo" @click="$emit(cmd.emetti, e)" class="aComandi" :class="cmd.iconaStile">
                    <font-awesome-icon :icon="'fa-solid ' + cmd.icona"></font-awesome-icon>
                </a>
            </td>
        </tr>
    </tbody>
    <tfoot>
        <tr v-if="mostraPager">
            <td :colspan="colonne.length + 1">
                <div class="d-flex justify-content-between">
                    <div>Elementi totali {{ queryLength }}, pagina {{ currentPage }} di {{PagineTotali}}</div>
                    <div>
                        <button type="button" class="btn btn-sm btn-outline-dark mx-1" 
                        v-for="p, i in CalcolaNumeri" :key="i" :class="{'btnSelected': currentPage == p}"
                        @click="$emit('CambiaPagina', p)">{{ p }}</button>
                    </div>
                    <div>
                        <button type="button" class="btn btn-sm btn-outline-dark" @click="$emit('Precedente')" v-if="currentPage > 1">&lt;&nbsp;Precedente</button>
                        <button type="button" class="btn btn-sm btn-outline-dark" @click="$emit('Successiva')" v-if="currentPage < PagineTotali">Successiva&nbsp;&gt;</button>
                    </div>
                </div>

                
                
            </td>
        </tr>
        <tr v-else>
            <td :colspan="colonne.length + 1">
                <div>Elementi totali {{ queryLength }}</div>
            </td>
        </tr>
    </tfoot>
  </table>
</template>

<script>

export default {
    name: "GrigliaFacile",
    props: {
        mostraPager: {
            type: Boolean,
            default: false
        },
        classiTable: {
            type: String,
            default: ""
        },
        colonneHeader: [],
        colonne: [],
        colonneNoOrder: [],
        dati: [],
        comandi: [],
        queryLength: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
    },
    data: function() {
        return {
            elementiPagina: "10",
        }
    },
    methods: {
        GetValue(o, i) {
            return eval('o.' + this.colonne[i]);
        },
        IsBoolean(o, i) {
            let t = eval('typeof o.' + this.colonne[i]);
            if(t == 'boolean') return true;
            else return false;
        }
    },
    computed: {
        PagineTotali() {
            return Math.ceil(this.queryLength  / this.elementiPagina);
        },
        CalcolaNumeri() {
            let res = [];
            let pages = Math.ceil(this.queryLength  / this.elementiPagina);
            let start = this.currentPage;
            if(this.currentPage == 1) start = 1;
            if(this.currentPage == 2) start = 1;
            if(this.currentPage >= 3) start = this.currentPage-2;
            for(let i = start; i < start + 4; i++) {
                if(i <= pages) {
                    res.push(i);
                }
            }

            return res;
        }

    } 
    
}
</script>

<style scoped>
    table th {
        color: #fff;
        background-color: #009038;
        padding-left:10px;
        padding-right:10px;
        padding-top:5px;
        padding-bottom:5px;
    }
    table thead {
        border-bottom:solid 2px #ccc;
    }
    table tfoot tr {
        border-top:solid 2px #1f1f1f;
    }

    a.aComandi {
        margin-right: 3px;
    }

    a.aOrdina {
        color: #ccc;
    }
    a.aOrdina :hover{
        color: #1f1f1f;
    }

    button.btnSelected {
        color: #fff;
        background-color: #666;
    }
</style>